module.exports = __webpack_public_path__ + "static/media/first-image.d3391501.png";